import { TableCell, TableRow, TableBody as UITableBody } from "@/components/ui/table";
import { LoadingTableBody } from "./LoadingTableBody";
import { TableEmptyRow } from "./Rows/TableEmptyRow";
import { TableDataRow } from "./Rows/TableDataRow";
import { TableBodyProps } from "@/types/list";
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export const TableBody = <TData,>({
	rows,
	allColumns,
	renderCell,
	renderRowClassName,
	layout,
	pageSize,
	expandedRowPanel,
}: TableBodyProps<TData>) => {
	if (layout.loading) {
		return <LoadingTableBody spinnerText={layout.spinnerText} allColumns={allColumns} pageSize={pageSize} />;
	}

	if (layout.errorMessage) {
		return (
			<UITableBody>
				<TableEmptyRow
					rowclassName="bg-red-50 hover:bg-red-50 transition"
					className="text-red-600"
					colSpan={allColumns.length}
					text={layout.errorMessage}
				/>
			</UITableBody>
		);
	}

	if (rows.length === 0) {
		return (
			<UITableBody>
				<TableEmptyRow colSpan={allColumns.length} text={layout?.emptyMessage || "No results."} />
			</UITableBody>
		);
	}

	return (
		<UITableBody>
			{rows.map(row => (
				<React.Fragment key={row.id}>
					<TableDataRow
						rowClassName={layout?.rowClassName}
						row={row}
						renderCell={renderCell}
						renderRowClassName={renderRowClassName}
					/>
					<AnimatePresence initial={false}>
						{row.getIsExpanded() && expandedRowPanel && (
							<TableRow className="hover:bg-transparent">
								<TableCell colSpan={row.getVisibleCells().length} className="!p-0 !m-0">
									<motion.div
										initial={{ height: 0, opacity: 0 }}
										animate={{ height: "auto", opacity: 1 }}
										exit={{ height: 0, opacity: 0 }}
										transition={{ duration: 0.3, ease: "easeInOut" }}
									>
										{expandedRowPanel(row)}
									</motion.div>
								</TableCell>
							</TableRow>
						)}
					</AnimatePresence>
				</React.Fragment>
			))}
		</UITableBody>
	);
};
